import React from "react";
import {
  Timeline,
  Events,
  UrlButton,
  ImageEvent,
  TextEvent,
  YouTubeEvent,
  themes,
  createTheme,
} from "@merc/react-timeline";
import { Container, Row, Col } from "react-bootstrap";
import css from "./timeline-styles.css";
import { Helmet } from "react-helmet-async";
import NavBarTop from "../NavBarTop/NavBarTop";
import Footer from "../Footer/Footer";

const customTheme = createTheme(themes.default, {
  card: {
    backgroundColor: "#50678b",
    color: "#FFFFFF",
  },
  urlButton: {
    backgroundColor: "#28a745",
    padding: "15px",
  },

  date: {
    backgroundColor: "#264068",
  },
  marker: {
    borderColor: "#264068",
    lineHeight: "60px",
  },
  timelineTrack: {
    backgroundColor: "white",
  },
});

export default function App() {
  return (
    <>
      <Helmet>
        <meta charSet="utf-8" />
        <title>SerpMaze.com | Free SERP Checker</title>
        <meta
          name="description"
          content="Find out what position you are ranking on Google on keywords of your own choice. Free and easy setup. Go ahead and test out SerpMaze for free now."
        />
        <meta name="theme-color" content="#008f68" />
        <meta name="twitter:card" content="summary" />
        {/*         <meta name="twitter:site" content="@nytimesbits" />
        <meta name="twitter:creator" content="@nickbilton" /> */}
        <meta property="og:url" content="https://serpmaze.com/" />
        <meta property="og:title" content="SerpMaze.com | Free SERP Checker" />
        <meta
          property="og:description"
          content="Find out what position you are ranking on Google on keywords of your own choice. Free and easy setup. Go ahead and test out SerpMaze for free now."
        />
        {/*         <meta
          property="og:image"
          content="http://graphics8.nytimes.com/images/2011/12/08/technology/bits-newtwitter/bits-newtwitter-tmagArticle.jpg"
        /> */}{" "}
      </Helmet>
      <div className="outer-wrapper-top-div">
        <Container fluid>
          <NavBarTop />
          <Row>
            <Col style={{ display: "flex", justifyContent: "center" }}>
              <Timeline theme={customTheme}>
                <Events>
                  <ImageEvent
                    date="23-11-22"
                    src="https://res.cloudinary.com/dfb584zgd/image/upload/v1669206923/SerpMaze/Only_possible_to_use_seo_auditor_on_frontpage_one_time_now_h5r4vz.png"
                    text={`It's now only possible to use the SEO auditor on the frontpage one time.\n\n However, if you would like to audit more sites, then just sign up.`}
                    alt={`It's now only possible to use the SEO auditor on the frontpage one time.`}
                    credit="Photo by SerpMaze.com"
                  ></ImageEvent>

                  <YouTubeEvent
                    date="21-11-2022"
                    id="35Jonn8h9uU"
                    name="First part of the Schema generator is now live."
                    text={`The first part of the Schema generator is now live. You find it under "Schema generator" within SerpMaze.\n\n You can use it to make sure your pages have added structured data correctly.\n\n Having structured data on your pages helps search engines understand how to display content the best way.\n\n You can see here how it works (no sound).`}
                  />

                  <YouTubeEvent
                    date="18-11-2022"
                    id="xO2gbgWwvTY"
                    name="Smoother way of adding keywords."
                    text={`There is now a new section called "meta checker" within SerpMaze.\n\n You can use it to check that your meta titles and descriptions are of correct lenght.\n\n It also makes it easy to get a quick overview of what a result in Google would look like, with what you entered.`}
                  />

                  <YouTubeEvent
                    date="17-11-2022"
                    id="MaJzUkl6vZs"
                    name="Smoother way of adding keywords."
                    text={`The way you add keywords is now a bit smoother.`}
                  />
                  <ImageEvent
                    date="16-11-22"
                    src="https://res.cloudinary.com/dfb584zgd/image/upload/v1668590189/SerpMaze/Possible_to_add_competitors_zhw8rr.png"
                    text={`It is now possible to add competitors.\n\n This makes it easier to see how your website is performing compared to your competitors.`}
                    alt={`It is now possible to add competitors.`}
                    credit="Photo by SerpMaze.com"
                  ></ImageEvent>
                  <ImageEvent
                    date="14-11-22"
                    src="https://res.cloudinary.com/dfb584zgd/image/upload/v1668415247/SerpMaze/Screenshot_2022-11-14_at_08.38.25_s7gtnw.png"
                    text={`Small issue with the keyword tracker fixed.\n\n People had been writing us that their keywords were not always updating daily. That has now been fixed.`}
                    alt={`Small issue with the keyword tracker fixed`}
                    credit="Photo by SerpMaze.com"
                  ></ImageEvent>
                  <YouTubeEvent
                    date="4-11-2022"
                    id="u_goGr-g9ZU"
                    name="Keyword tracker now have 6 summary cards."
                    text={`Keyword tracker now have <b>6 summary cards</b>.\n\n <b>Average position</b> Average position is the sum of all your keyword positions divided by the amout of keywords you are tracking.\n\n <b>Improved</b> Improved shows the amount of keywords that have improved compared to the previous day.\n\n <b>Top 3</b> Top 3 shows the amount of keywords you are tracking that are ranking in top 3.\n\n <b>Top 10</b> Top 10 shows the amount of your keywords that are ranking in top 10.\n\n <b>Top 30</b> Top 30 shows the amount of your keywords that are ranking in top 30.\n\n <b>Top 100</b> Top 100 shows the amount of your keywords that are ranking in top 100.`}
                  />
                  <ImageEvent
                    date="2-11-22"
                    src="https://res.cloudinary.com/dfb584zgd/image/upload/v1667463333/SerpMaze/Change_Latest_First_Best_added_to_keyword_tracker_rbtzjz.png"
                    text={`Keyword tracker now showing "Change", "Latest", "Best" and "First.\n\n "Change" is the difference between yesterdays position and today's.\n\n "Latest" is the latest position.\n\n "Best" is the highest position since starting to track the keyword.\n\n "First" is the position you had when you first added the keyword.`}
                    alt={`Keyword tracker now showing "Change", "Latest", "Best" and "First"`}
                    credit="Photo by SerpMaze.com"
                  ></ImageEvent>
                  <ImageEvent
                    date="1-11-22"
                    text={`First testimonial received from Pål Kaalaas, Senior SEO Consultant at NoA Connect.`}
                    src="https://res.cloudinary.com/dfb584zgd/image/upload/v1667301962/SerpMaze/Pa%CC%8Al_Kaalaas-_Senior_SEO_consultant_at_NoA_Connect_iqogo2.jpg"
                    alt="Testimonial from Pål Kaalaas."
                    credit="Photo by SerpMaze.com"
                  ></ImageEvent>

                  <ImageEvent
                    date="31-10-22"
                    text={`Weekly automated email with overall SEO score now being sent out to all users.`}
                    src="https://res.cloudinary.com/dfb584zgd/image/upload/v1667378235/SerpMaze/Weekly_automated_email_-_Serpmaze_djjlvn.png"
                    alt="Weekly automated email - Serpmaze."
                    credit="Photo by SerpMaze.com"
                  ></ImageEvent>

                  <ImageEvent
                    date="28-10-22"
                    text={`Launched on Product Hunt! 🏁 `}
                    src="https://res.cloudinary.com/dfb584zgd/image/upload/v1667228264/SerpMaze/Product_Hunt_launch_ybma88.png"
                    alt="Launched on Product Hunt."
                    credit="Photo by SerpMaze.com"
                  >
                    <div>
                      <UrlButton
                        style={{ backgroundColor: "black" }}
                        target="_blank"
                        href="https://www.producthunt.com/posts/serpmaze-com"
                      >
                        Check Product Hunt launch
                      </UrlButton>
                    </div>
                  </ImageEvent>
                  <ImageEvent
                    date="26-10-22"
                    text={`On the paid plan you can now track 100 keywords.`}
                    src="https://res.cloudinary.com/dfb584zgd/image/upload/v1666791688/SerpMaze/Possible_to_track_100_keywords_on_paid_plan_bzcak3.png"
                    alt="On the paid plan you can now track 100 keywords."
                    credit="Photo by SerpMaze.com"
                  ></ImageEvent>

                  <ImageEvent
                    date="25-10-22"
                    text={` Trend graph added to keyword tracker. That makes it easy to follow your historic rankings for your keywords.`}
                    src="https://res.cloudinary.com/dfb584zgd/image/upload/v1666791494/SerpMaze/Trend_added_to_keyword_tracker_x5ista.png"
                    alt="Trend graph added to keyword tracker."
                    credit="Photo by SerpMaze.com"
                  ></ImageEvent>
                  <ImageEvent
                    date="22-10-22"
                    text={`Keywords and the overall SEO report are now being updated once every 24th hour.`}
                    src="https://res.cloudinary.com/dfb584zgd/image/upload/v1666791374/SerpMaze/Keywords_and_overall_seo_report_now_updated_every_24_hour_cd4jby.png"
                    alt="Keywords and overall SEO report now updated every 24 hour."
                    credit="Photo by SerpMaze.com"
                  ></ImageEvent>
                  <ImageEvent
                    date="17-10-22"
                    text={`Top domains now shown for all keywords you are tracking. Just click the "Top Domains" button.`}
                    src="https://res.cloudinary.com/dfb584zgd/image/upload/v1665996923/SerpMaze/Top_domains_for_a_keyword_l2dftp.png"
                    alt="Top domains now shown"
                    credit="Photo by SerpMaze.com"
                  ></ImageEvent>

                  <ImageEvent
                    date="13-10-22"
                    text={`The new dashboard is now live! With it you get an overview of your websites current score and issues, a graph showing the history of your overall SEO score as well as an overview of your tracked keywords.`}
                    src="https://res.cloudinary.com/dfb584zgd/image/upload/v1665686446/SerpMaze/New_dashboard_design_n871ht.png"
                    alt="New dashboard live"
                    credit="Photo by SerpMaze.com"
                  ></ImageEvent>

                  <ImageEvent
                    date="3-10-22"
                    text={`The keyword tracker has now gotten an updated design. Go check it out.`}
                    src="https://res.cloudinary.com/dfb584zgd/image/upload/v1665686340/SerpMaze/New_Design_of_the_Keyword_tracker_aidalj.png"
                    alt="New design of the keyword tracker"
                    credit="Photo by SerpMaze.com"
                  ></ImageEvent>
                  <ImageEvent
                    date="26-9-22"
                    text={`Outgoing no-follow links added.\n\n No-follow links are used to link to a page, without giving any ranking credit or link-juice to that specific site.`}
                    src="https://res.cloudinary.com/dfb584zgd/image/upload/v1664198600/SerpMaze/Outgoing_no-follow_links_krqfm6.png"
                    alt="Outgoing no-follow links added"
                    credit="Photo by SerpMaze.com"
                  ></ImageEvent>

                  <ImageEvent
                    date="26-9-22"
                    text={`Start tracking your keywords box added.`}
                    src="https://res.cloudinary.com/dfb584zgd/image/upload/v1664198313/SerpMaze/Start-tracking-your-keywords-box_sav9ra.png"
                    alt="Start tracking your keywords box added"
                    credit="Photo by SerpMaze.com"
                  ></ImageEvent>

                  <ImageEvent
                    date="23-9-22"
                    text={`It is now possible to see internal and external links.\n\n Search engines are analysing internal links in order to understand what pages are the most important pages on a website.\n\n External links have impact on search engine rankings as they enhance a website's authority.`}
                    src="https://res.cloudinary.com/dfb584zgd/image/upload/v1663940931/SerpMaze/Internal_and_external_links_added_h9nttl.png"
                    alt="It is now possible to see internal and external links"
                    credit="Photo by SerpMaze.com"
                  ></ImageEvent>

                  <ImageEvent
                    date="22-9-22"
                    text={`Added a most used keywords section.\n\n Here you can see what keywords are used the most for a site.`}
                    src="https://res.cloudinary.com/dfb584zgd/image/upload/v1663859191/SerpMaze/Most-used-keywords-section_pex6uq.png"
                    alt="Added a most used keywords section"
                    credit="Photo by SerpMaze.com"
                  ></ImageEvent>

                  <ImageEvent
                    date="22-9-22"
                    text={`It is now possible to see what domains a SSL certificate i valid for.`}
                    src="https://res.cloudinary.com/dfb584zgd/image/upload/v1663831552/SerpMaze/Possible-to-see-what-domains-a-ssl-certificate-is-valid-for_zskgy4.png"
                    alt="Possible to see what domains a SSL certificate is valid for"
                    credit="Photo by SerpMaze.com"
                  ></ImageEvent>

                  <ImageEvent
                    date="21-9-22"
                    text={`Server and security section added.\n\n These tests include SSL and HTTPS checks.`}
                    src="https://res.cloudinary.com/dfb584zgd/image/upload/v1663757361/SerpMaze/Server-and-security-section-added_mlqxwq.png"
                    alt="Server and security section added"
                    credit="Photo by SerpMaze.com"
                  ></ImageEvent>

                  <ImageEvent
                    date="20-9-22"
                    text={`Overall SEO score added.\n\n This make it easy to see the "health" of a site, as well as how it can be improved.`}
                    src="https://res.cloudinary.com/dfb584zgd/image/upload/v1663682535/SerpMaze/Overall_SEO_Score_added_gebnyd.png"
                    alt="Overall SEO score"
                    credit="Photo by SerpMaze.com"
                  ></ImageEvent>

                  <ImageEvent
                    date="16-9-22"
                    text={`Added a Google search results preview test.\n\n This makes it easy to see what your webpage will look like in a Google search result.`}
                    src="https://res.cloudinary.com/dfb584zgd/image/upload/v1663321859/SerpMaze/Google_Search_Results_Preview_Test_kmedui.png"
                    alt="Added a Google search results preview test"
                    credit="Photo by SerpMaze.com"
                  ></ImageEvent>
                  <ImageEvent
                    date="15-9-22"
                    text={`Added favicon checker to SEO auditor.\n\n A favicon is a small icon associated with a website.`}
                    src="https://res.cloudinary.com/dfb584zgd/image/upload/v1663240270/SerpMaze/Favicon_test_added_pwjfd6.png"
                    alt="Added favicon checker to SEO auditor"
                    credit="Photo by SerpMaze.com"
                  ></ImageEvent>

                  <ImageEvent
                    date="14-9-22"
                    text={`Added Robots.txt checker to SEO auditor.\n\n That way you can easily find out if your website is missing a Robots.txt file.`}
                    src="https://res.cloudinary.com/dfb584zgd/image/upload/v1663170549/SerpMaze/Robots-txt-checker-added_mps2qg.png"
                    alt="Added Robots.txt checker to SEO auditor."
                    credit="Photo by SerpMaze.com"
                  ></ImageEvent>

                  <YouTubeEvent
                    date="12-9-2022"
                    id="wsUGPRE7bsU"
                    name="SEO auditor live."
                    text={`SEO auditor is now live.\n\n All you need to do is add your website url and you will receive onsite SEO recommendations on how you can optimize your SEO.`}
                  />

                  <YouTubeEvent
                    date="1-9-2022"
                    id="UX_ugixKc9Y"
                    name="Made a free H-tags checker, making it possible to check any page's H-tags in seconds."
                    text={`Made a free H-tags checker, making it possible to check any page's H-tags in seconds.\n\n For optimizing your SEO, all of the important pages on your site should have H1 tags to draw in the reader and give a clear indication of the content on the page.\n\n Try to only have one H1 per page, to not confuse search engines.\n\n You can check how many H1 tags you have, by using our free H-tag checker right <a href="https://serpmaze.com/free-h-tag-checker">here.</a> `}
                  />

                  <ImageEvent
                    date="30-8-22"
                    text={`Added a smoother way of adding more keywords.\n\n It makes it much easier to add and remove what you have typed.`}
                    src="https://res.cloudinary.com/dfb584zgd/image/upload/v1661875373/SerpMaze/Smoother_way_of_adding_more_keywords_ytw1or.png"
                    alt="Smoother way of adding more keywords"
                    credit="Photo by SerpMaze.com"
                  ></ImageEvent>

                  <YouTubeEvent
                    date="26-8-2022"
                    id="xfQUQI-eew8"
                    name="Historic ranking data for keywords now being shown in a graph."
                    text={`Historic ranking data for your keywords is now being shown in a graph underneath the "top 10".\n\n As long as you remember to update your keywords you will see your historic ranking results in a graph for each keyword.`}
                  />

                  <YouTubeEvent
                    date="23-8-2022"
                    id="Iw-ua2nzElI"
                    name="We made a free meta title and description checker."
                    text={`We made a free meta title and description checker.\n\n You can use it to check if you have remembered to add a meta title and a meta description to your site.\n\n Meta titles and meta descriptions are very important Google ranking factors.\n\n You can check it out  <a href="https://serpmaze.com/free-meta-title-and-description-checker">here.</a>`}
                  />

                  <ImageEvent
                    date="19-8-22"
                    text={`We have added two more paid packages.\n\n You can now choose between 10, 60 or 250 keywords with daily updates.\n\n You can see all packages on our pricing page.`}
                    src="https://res.cloudinary.com/dfb584zgd/image/upload/v1660926395/SerpMaze/SerpMaze_prices_o8fy49.png"
                    alt="We have added two more paid packages"
                    credit="Photo by SerpMaze.com"
                  ></ImageEvent>

                  <YouTubeEvent
                    date="18-8-2022"
                    id="dvP-dbGi7M0"
                    name="You can now change your keyword one time as a non-paying user."
                    text="You can now change your keyword one time as a non-paying user."
                  />
                  <TextEvent
                    date="18-8-2022"
                    text={`We got our first paying customer! 🍾`}
                  />
                  <YouTubeEvent
                    date="14-8-2022"
                    id="bYSaWV9ti0U"
                    name="Google region dropdown is now searchable."
                    text="Google region dropdown is now searchable."
                  />

                  <TextEvent
                    date="12-8-2022"
                    text={`Scrolldown-feature on frontpage added!\n\n When you fetch your result on the frontpage it will scroll down to the bottom to see the result.\n\n This is particularly useful on mobile screens.`}
                  />

                  <ImageEvent
                    date="8-8-22"
                    text="Paid version now available on SerpMaze.com!"
                    src="https://res.cloudinary.com/dfb584zgd/image/upload/v1660306003/SerpMaze/Paid_version_snapshot_serpmaze_p8cpph.png"
                    alt="Paid version of SerpMaze.com"
                    credit="Photo by SerpMaze.com"
                  ></ImageEvent>

                  <TextEvent
                    date="1-8-2022"
                    text={`Free version of SerpMaze.com is now live!\n\nYou can sign up for free and track 1 keyword - also for free.\n\n You are welcome!`}
                  />
                </Events>
              </Timeline>
            </Col>
          </Row>
        </Container>
        <Footer />
      </div>
    </>
  );
}
